import { render, staticRenderFns } from "./OrganizationUserMembership.vue?vue&type=template&id=5ba706f7&"
import script from "./OrganizationUserMembership.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserMembership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports